import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { InternalLocalFileReportInstance, InternalLocalFileReport, Report, FinalLocalReport, FinalReport, ReportInstance } from '../models';
@Injectable()
export class InternalLocalFileReportService extends BaseService<InternalLocalFileReport> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public listLocalFileReportInstances(id: number): Observable<InternalLocalFileReportInstance[]> {
    return this.http.get<InternalLocalFileReportInstance[]>(`${this.getResourceUrl()}${id}/instance`);
  }

  public delete(id: number): Observable<InternalLocalFileReportInstance[]> {
    return this.http.delete<InternalLocalFileReportInstance[]>(`${this.getResourceUrl()}${id}`);
  }

  // tslint:disable-next-line:max-line-length
  public deleteLocalFileReportInstance(localFileId: number, instanceId: number): Observable<InternalLocalFileReportInstance[]> {
    // tslint:disable-next-line:max-line-length
    return this.http.delete<InternalLocalFileReportInstance[]>(`${this.getResourceUrl()}${localFileId}/instance/${instanceId}`);
  }

  public updateTitle(title: string, id: number): Observable<string> {
    return this.http.patch<string>(`${this.getResourceUrl()}${id}`, { title });
  }

  public updateFinalFlag(id: number, instanceId: number, finalStatus: boolean): Observable<any> {
    return this.http.patch<any>(`${this.getResourceUrl()}${id}/instance/${instanceId}`, { isFinal: finalStatus });
  }

  public unpublishReport(id: number, instanceId: number): Observable<any> {
    return this.http.delete<any>(`${this.getResourceUrl()}${id}/instance/${instanceId}/unpublish`);
  }

  public publishReport(id: number, instanceId: number, containerId: number): Observable<any> {
    return this.http.post<any>(`${this.getResourceUrl()}${id}/instance/${instanceId}/publish`, { containerId });
  }

  public getLocalFileWorkingReports(domicileId: number): Observable<Report[]> {
    const apiUrl = `${this.getResourceUrl()}domicile/${domicileId}/working-reports`;
    return this.http.get<InternalLocalFileReport[]>(apiUrl).pipe(map(this.mapWorkingReportsToGeneric));
  }

  public getLocalFileFinalReports(domicileId: number): Observable<FinalReport[]> {
    const apiUrl = `${this.getResourceUrl()}domicile/${domicileId}/final-reports`;
    return this.http.get<FinalLocalReport[]>(apiUrl).pipe(map(this.mapFinalReportsToGeneric));
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}internal-local-file-reports/`;
  }

  private mapWorkingReportsToGeneric(reports: InternalLocalFileReport[]): Report[] {
    return reports.map((report: InternalLocalFileReport) => {
      const genericReport: Report = {
        reportId: report.internalLocalfileReportId,
        name: report.name,
        collapsed: report.collapsed
      };
      return genericReport;
    });
  }

  private mapFinalReportsToGeneric(reports: FinalLocalReport[]): FinalReport[] {
    return reports.map((report: FinalLocalReport) => {
      const genericReport: FinalReport = {
        binaryPath: report.binaryPath,
        collapsed: report.collapsed,
        comment: report.comment,
        contactName: report.contactName,
        division: report.division,
        documentType: report.documentType,
        reportInstance: {
          ...report.internalLocalfileReportInstance,
          reportInstanceId: report.internalLocalfileReportInstance && report.internalLocalfileReportInstance.internalLocalfileReportInstanceId,
          status: report.internalLocalfileReportInstance && report.internalLocalfileReportInstance.status && report.internalLocalfileReportInstance.status.internalLocalfileReportInstanceStatusId,
        } as ReportInstance,
        reportFinalId: report.localfileReportId,
        name: report.name,
        productLine: report.productLine
      };

      return genericReport;
    });
  }
}
